export default __webpack_public_path__ + "static/media/uncheck.3f3d40e7.png";